import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Imagine } from './components/Imagine';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-paper font-sans text-ink antialiased" data-id="element-0" data-mp="23vupqgmff2wq">
      <MetaPixel data-id="element-1" data-mp="23ti7018ugoim" />
      <UtmifyScript data-id="element-2" data-mp="3ik7eyd5x05p2" />
      <CountdownBar data-id="element-3" data-mp="3ikqwvtvkeu33" />
      <main data-id="element-4" data-mp="3ijfx0558q6h9">
        <Hero data-id="element-5" data-mp="3ijpe138b53at" />
        <StatsBar data-id="element-6" data-mp="3ii4s22026sok" />
        <Difference data-id="element-7" data-mp="3mlaxx8j9ehui" />
        <Recognize data-id="element-8" data-mp="3mkrcviybbdc9" />
        <WhatsInside data-id="element-9" data-mp="3mk83wrqn3zad" />
        <LookInside data-id="element-10" data-mp="3mjga9mglsbmq" />
        <InstantAccess data-id="element-11" data-mp="3rc9ca2kot5v4" />
        <Bonuses data-id="element-12" data-mp="3rbzmaezn6ypf" />
        <Offer data-id="element-13" data-mp="3rdkisa5iorpx" />
        <Guarantee data-id="element-14" data-mp="3rd1bdndhtlq5" />
        <Imagine data-id="element-15" data-mp="3relumgucxi8p" />
        <Faq data-id="element-16" data-mp="5otf64sd496" />
        <FinalCta data-id="element-17" data-mp="6htxpd5ixiv" />
      </main>
      <Footer data-id="element-18" data-mp="5gel8p3rovc" />
    </div>;
}